export type AppRoute =
  | { name: 'home' }
  | { name: 'tickets' }
  | { name: 'ticket'; ticketId: string }
  | { name: 'create'; type: 'reward' | 'penalty' }
  | { name: 'settings' }
  | { name: 'message'; token: string }
  | { name: 'invite'; token: string };

export function parseHashRoute(hash: string): AppRoute {
  if (hash.startsWith('#m=')) return { name: 'message', token: hash.slice(3) };
  if (hash.startsWith('#invite=')) return { name: 'invite', token: hash.slice(8) };
  if (hash.startsWith('#ticket/')) return { name: 'ticket', ticketId: hash.slice(8) };
  if (hash === '#tickets') return { name: 'tickets' };
  if (hash === '#create/reward') return { name: 'create', type: 'reward' };
  if (hash === '#create/penalty') return { name: 'create', type: 'penalty' };
  if (hash === '#settings') return { name: 'settings' };
  return { name: 'home' };
}
